<template>
  <page-frame headStyle="height:2.12rem" bodyStyle="top:2.12rem">
    <header-bar slot="head" navStyle="padding-left:.266rem;padding-right:.266rem;">
      <span>{{ $t(objSave.centerTitle) }}</span>
      <span slot="right" @click="saveInfos">{{ $t('share.Save') }}</span>
    </header-bar>
    <div style="text-align:left;">
      <li style=" padding: 0 0.266rem 0.266rem 0.266rem;background-color:#fff">
        <travelerName @ChangeToggleFlag="ChangeToggleFlag" :Types="Types" :ToggleFlag="ToggleFlag" v-model="model" :CardsLists="CardsLists"> </travelerName>
        <certificateInformation v-model="model" :CardsLists="CardsLists" :Types="Types"> </certificateInformation>
        <otherInfos :ContactInfo="model.ContactInfo" :RoleInfo="model"> </otherInfos>

        <div class="reminderInfos">
          <span>!</span>
          <span>{{ $t("mall.reminderInfos") }}</span>
        </div>
        <div class="delectTraveler" v-if="RoleID != undefined" @click="delCard">{{ $t("system_mall_addtraveller_shanchu") }}</div>
      </li>
    </div>
  </page-frame>
</template>
<style scoped>
  .header-menu {
    background-color: #12a3ff;
  }

  .optionalInfos {
    margin-top: 0.266rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .optionalInfos label {
    height: 1.197rem;
    line-height: 1.197rem;
  }

  .reminderInfos {
    padding-top: 0.532rem;
    font-size: 0.3192rem;
    display: flex;
    justify-content: space-between;
  }

  .reminderInfos > span:first-child {
    width: 0.399rem;
    color: red;
    height: 1.596rem;
    display: inline-block;
  }

  .reminderInfos > span:last-child {
    height: 1.596rem;
    display: inline-block;
  }

  .marks {
    font-size: 0.3192rem;
    padding: 0.133rem 0 0.133rem 0.266rem;
  }

  .delectTraveler {
    text-align: center;
    background-color: #12a3ff;
    margin: 0.798rem auto;
    width: 90%;
    height: 1.064rem;
    line-height: 1.064rem;
    color: #fff;
    font-weight: bold;
    border-radius: 0.106rem;
  }

  .delectTraveler img {
    height: 0.638rem;
  }
</style>
<script>
  import SwitchOption from "../modules/switch-option.vue";
  import datePicker from "../modules/date-picker.vue";
  import picker from "../modules/picker.vue";
  import Scroll from "../modules/Scroll.vue";
  import otherInfos from "./modules/otherInfos.vue";
  import certificateInformation from "./modules/certificateInformation.vue";
  import travelerName from "./modules/travelerName.vue";
  import navBar from "../modules/navBar.vue";
  import moment from "moment";
  import UserService from "@/service/UserService";
  import { CardType, RoleType, Sex } from "@/model/Base";
  let card_model = {
    CardID: "",
    CardType: "1138",
    CardNo: "",
    ExpireDate: moment().format("YYYY-MM-DD"),
    IssueCountry: "",
    EnglishLastName: "",
    EnglishFirstName: "",
  };
  export default {
    data() {
      return {
        isAutoPlay: true,
        objSave: {
          centerTitle: "mall.addOrEditTraveller",
          rightTitle: {
            isShow: true,
            type: "button",
            label: "share.Save",
            fnName: "fnSave",
          },
        },
        model: {
          Cards: [],
          FirstName: "",
          LastName: "",
          RoleNick: "",
          RoleIcon: "",
          Country: 151,
          CountryCode: "CN",
          BirthDate: moment("1980-01-01").format("YYYY-MM-DD"),
          RoleGenre: 1145,
          RoleID: "",
          RoleName: "",
          RoleType: 1311,
          RoleStatus: "",
          OwnerID: "",
          LevelCode: "",
          Remark: "",
          TimeMode: "",
          OauthDay: "",
          OauthTime: "",
          actions: [],
          Superior: {},
          ContactInfo: {
            Address: "",
            CityID: 0,
            ContactEmail: "",
            ContactID: "",
            ContactName: "",
            ContactPeople: "",
            ContactPhone: "",
            CreateTime: "",
            CreateTimeEnd: null,
            CreateUserID: "",
            CreateUserName: "",
            DistrictID: 0,
            FullAddress: "",
            IsDefault: 0,
            PostCode: "",
            ProvinceID: 0,
            RoleID: "",
            UpdateTime: "",
            UpdateTimeEnd: null,
            UpdateUserID: "",
            UpdateUserName: "",
          },
          Commons: [],
          Roles: [],
          RootID: "",
        },
        CardsListClone: _.clone(card_model),
        Types: {
          Card: "1138",
        },
        CountryLists: [],
        ToggleFlag: false,
      };
    },
    computed: {
      // ConsumerIndex() {
      //   return this.$route.query.ConsumerIndex;
      // },
      RoleID() {
        return this.$route.query.RoleID;
      },
      CardType() {
        return this.$route.query.CardType;
      },
      UserID() {
        return this.profile.UserID;
      },
      CompanyID() {
        return this.profile.CompanyID;
      },
      CardsLists() {
        let __self = this;
        let data = _.filter(__self.model.Cards, o => o.CardType == __self.Types.Card);
        return data;
      },
    },
    watch: {
      "Types.Card"(newVal) {
        let __self = this;
        let CardsList = _.clone(card_model);
        let Card = _.find(__self.model.Cards, o => o.CardType == newVal);
        if (Card == undefined) {
          CardsList.CardType = newVal;
          __self.model.Cards.push(CardsList);
        }
      },
    },
    created() {
      let __self = this;
      if (__self.RoleID != undefined) {
        __self.__init();
      }
      __self.Types.Card = __self.CardType;
    },
    mounted() {
      let __self = this;
    },
    activated() {
      let __self = this;
    },
    methods: {
      __init() {
        let __self = this;
        let data = {};
        data.RoleID = __self.RoleID;
        UserService.getRoleInfo(data).then(function(json) {
          if (json.isSucc) {
            if (json.result.Country == 0) {
              json.result.Country = 151;
              json.result.CountryCode = "CN";
            }
            if (json.result.Cards.length <= 0) {
              json.result.Cards.push(__self.CardsListClone);
            } else {
              let cardResilt = _.find(json.result.Cards, function(o) {
                return o.CardType == CardType.IDCard;
              });
              if (!cardResilt) {
                json.result.Cards.push(__self.CardsListClone);
              }
            }
            json.result.BirthDate = moment(json.result.BirthDate).format("YYYY-MM-DD");
            for (let i = 0; i < json.result.Cards.length; i++) {
              let Cards = json.result.Cards[i];
              Cards.ExpireDate = moment(Cards.ExpireDate).format("YYYY-MM-DD");
              if (Cards.CardType == 0) {
                Cards.CardType = CardType.IDCard;
              }
            }
            __self.model = json.result;
            // if ($utils.Storage[__self.ConsumerIndex] != undefined) {
            //   let Consumer = JSON.parse($utils.Storage[__self.ConsumerIndex]);
            //   Consumer.ExpireDate = Consumer.CardOverDate;
            //   __self.model.ContactInfo.ContactPhone = Consumer.ContactMobile;
            //   let Card = _.findIndex(__self.model.Cards, function(o) {
            //     return o.CardType == Consumer.CardType;
            //   });
            //   if (Consumer.lang == "en") {
            //     __self.ToggleFlag = true;
            //   } else {
            //     __self.ToggleFlag = false;
            //   }
            //   __self.model.RoleGenre = Consumer.ConsumerSex;
            //   if (Card == -1) {
            //     __self.model.Cards.push(Consumer);
            //   } else {
            //     let Cards = __self.model.Cards[Card];
            //     // __self.model.RoleName=Cards.RoleName;
            //     Cards.CardNo = Consumer.CardNo;
            //     Cards.CardType = Consumer.CardType;
            //     Cards.EnglishFirstName = Consumer.EnglishFirstName;
            //     Cards.EnglishLastName = Consumer.EnglishLastName;
            //     Cards.ExpireDate = Consumer.CardOverDate;
            //     Cards.lang = Consumer.lang;
            //     if (Cards.CardNo && Cards.CardNo != "" && Cards.CardType == 1138) {
            //       if (Consumer.ConsumerSex == 0 || !Consumer.ConsumerSex) {
            //         if (parseInt(Cards.CardNo.substr(16, 1)) % 2 == 1) {
            //           __self.model.RoleGenre = Sex.Male;
            //         } else {
            //           __self.model.RoleGenre = Sex.Female;
            //         }
            //       }
            //     } else {
            //       __self.model.RoleGenre = Sex.Male;
            //     }
            //     __self.model.Country = Consumer.CountryID;
            //     __self.model.BirthDate = moment(Consumer.Birthday).format("YYYY-MM-DD");
            //   }
            // }
          }
        });
      },
      ChangeToggleFlag(value) {
        let __self = this;
        __self.ToggleFlag = value;
      },
      saveInfos() {
        let __self = this;
        let Superior = {
          RoleID: "",
          RoleName: "",
          RoleType: RoleType.Customer,
          RootID: "",
        };
        Superior.RoleID = __self.CompanyID;
        Superior.RootID = __self.CompanyID;
        __self.model.RootID = __self.UserID;
        __self.model.Superior = Superior;
        let Card = _.find(__self.model.Cards, o => o.CardType == __self.Types.Card);
        if (__self.ToggleFlag) {
          Card.lang = "en";
        } else {
          Card.lang = "zh";
        }
        UserService.saveRoleInfo(__self.model).then(json => {
          if (json.isSucc) {
            this.$root.$toast.success(__self.$t("share.succ.SaveSucc"));
            history.back();
          }
        });
      },
      updateAutoPlay(value) {
        let __self = this;
        __self.isAutoPlay = value;
      },
      back() {
        history.back();
      },
      delCard() {
        let __self = this;
        this.$dialog
          .confirm({
            title: "",
            message: __self.$t("share.confirm.YesOrNoDelect"),
          })
          .then(() => {
            UserService.deleteRoleInfo(__self.RoleID, "", RoleType.Customer).then(o => {
              if (o.isSucc) {
                this.$root.$toast.success(o.message);
                history.back();
              }
            });
          })
          .catch(() => {
            // on cancel
          });
      },
    },
    components: {
      navBar,
      travelerName,
      certificateInformation,
      otherInfos,
      Scroll,
      picker,
      datePicker,
      SwitchOption,
    },
  };
</script>
